
import {defineComponent, ComputedRef, ref, Ref, computed, onMounted, reactive, watch, toRefs, onUnmounted} from 'vue'
import {useStore} from 'vuex'
import {useRouter} from 'vue-router'

import {UserOutlined, InfoCircleOutlined} from '@ant-design/icons-vue'
import {message, Form} from 'ant-design-vue'
import {validateInfos} from 'ant-design-vue/lib/form/useForm'
import {debounce} from 'lodash'

import {UserInfoParams} from '@/services/data.d'
import {StateType as CuntryStateType} from '@/store/country'
import {StateType as AreaStateType} from '@/store/area'
import {StateType as DestinationStateType} from '@/store/destination'
import {StateType as UploadStateType} from '@/store/upload'
import {StateType as UserStateType} from '@/store/user'
import {StateType as FddsignStateType} from '@/store/fddsign'
import {StateType as CurrencyStateType} from '@/store/currency'
import {StateType as UserStatusStateType} from '@/store/userstatus'
import useI18nAntdFormVaildateInfos from '@/composables/useI18nAntdFormVaildateInfos'
import {keepTwoNum} from '@/utils/number'
import {isIoss, isPostal} from '@/utils/validate'

import Address from './component/address/index.vue'
import Addsku from './component/AddSku.vue'
import NewlyAddedSku from './component/newlyaddedsku/index.vue'
import {
  SaveFormDataType,
  TableListQueryParams,
  FormDataType,
  SkuFormDataType,
  SkulistResTableType,
  validInfoType,
} from './data'
import {StateType as SetAddressStateType} from './store'
import {StateType as PersonalStateType} from './store'
import {StateType as AddlogisticsStateType} from './store'
import {StateType as SkuStateType} from './store'
import {StateType as validInfoGetType} from './store'

const useForm = Form.useForm

interface AddLogisticsData {
  visible: Ref<boolean>
  typeStr: Ref<string>
  loading: Ref<boolean>
  loadingl: Ref<boolean>
  title: ComputedRef<string>
  columns: any
  columns1: any
  columns2: any
  countrylist: Ref<any>
  modelRef: SkuFormDataType
  countrylistSet: Ref<any>
  list: Ref<any[]>
  listl: Ref<any[]>
  listSelect: ComputedRef<any[]>
  listlSelect: ComputedRef<any[]>
  skuList: Ref<any[]>
  validateInfos: ComputedRef<validateInfos>
  currtypelist: ComputedRef<any[]>
  serveDataList: Ref<any[]>
  isNum: Ref<any>
  isBoolean: Ref<boolean>
  isSubmit: Ref<boolean>;
  handleModal: (type: string, record: any) => void
  filterOption: (input: string, option: any) => any
  getLogistData: (value: SaveFormDataType) => Promise<void>
  getaddskuData: (value: FormDataType) => Promise<void>
  skuEmitData: (e: any) => any
  getIsAddSkuBtn: (value: boolean) => any
  postFromData: (e: MouseEvent) => void
  handleDestination: (e: MouseEvent) => void
  handleSearch: (value: any) => void
  handleSelect1: (value: any) => void
  handleSelect2: (value: any) => void
  handleChangeSelect: (value: any) => void
  handleChangeSelect2: (value: any) => void
  handleBack: (type: string) => void
  handleSelectDes: (e: MouseEvent) => void
  handleChangeNumber: (e: MouseEvent) => void
  handleGotoCheck: (type: string) => void
  changeTxt: (t: string, type: string) => string
  handleCheckMsg: (type: string) => void
}

export default defineComponent({
  name: 'addlogistics',
  components: {
    UserOutlined,
    InfoCircleOutlined,
    Address,
    Addsku,
    NewlyAddedSku,
  },
  setup(): AddLogisticsData {
    const router = useRouter()
    const visible = ref<boolean>(false)
    const typeStr = ref<string>('')
    const loading = ref<boolean>(false)
    const loadingl = ref<boolean>(false)
    const userMsg = (localStorage.getItem('userMsg') && JSON.parse(localStorage.getItem('userMsg') as string)) || {}
    const countrylist = ref<any>([])
    const countrylistSet = ref<any>([])
    const skuList = ref<any[]>([])
    const serveDataList = ref<any[]>([])
    const state = reactive({data: []})
    const isNum = ref<any>()
    const isBoolean = ref<boolean>(false)
    const list = ref<any[]>([])
    const listl = ref<any[]>([])
    const isSubmit = ref<boolean>(false)
    let lastFetchId = 0
    let lh = 0,
      wh = 0,
      ht = 0 //lh长，wh宽，ht高
    let wetSub = 0,
      amSub = 0 //wetSub包裹总重量，amSub包裹总申报价值
    const store = useStore<{
      setaddress: SetAddressStateType
      country: CuntryStateType
      area: AreaStateType
      personal: PersonalStateType
      upload: UploadStateType
      user: UserStateType
      fddsign: FddsignStateType
      sku: SkuStateType
      addlogistics: AddlogisticsStateType
      destination: DestinationStateType
      valid: validInfoGetType
      currency: CurrencyStateType
      userstatus: UserStatusStateType
    }>()
    const columns = [
      {title: 'SKU编码', dataIndex: 'skuCode', ellipsis: true},
      {title: '申报中文名称', dataIndex: 'declareNameCn', ellipsis: true},
      {title: '申报英文名称', dataIndex: 'declareNameEn', ellipsis: true},
      {title: '商品属性', dataIndex: 'hasBattery', ellipsis: true},
      {title: '数量', dataIndex: 'declareNumber', ellipsis: true},
      {title: '单货品申报价值', dataIndex: 'declareValue', ellipsis: true},
      {title: '申报币种', dataIndex: 'declareCurrency', ellipsis: true},
      {title: '单货品申报重量(g)',dataIndex: 'declareWeight',width:160},
      {title: '单品申报尺寸(长*宽*高)',dataIndex: 'dHeight',width:180},
      {title: '单品实测重量', dataIndex:'realWeight'},
      {title: '单品实测尺寸(长*宽*高)', dataIndex:'rHeight',width:180},
      {title: '海关编码', dataIndex: 'hsCode', ellipsis: true},
      {title: '操作', dataIndex: 'action', fixed: 'right', width: 180, align: 'center', ellipsis: true},
    ]

    const columns1 = [
      {title: '地址名称', dataIndex: 'addressName'},
      {title: '联系人姓名', dataIndex: 'contacts'},
      {title: '手机号码', dataIndex: 'mobilePhone'},
      {title: '省', dataIndex: 'province'},
      {title: '市', dataIndex: 'city'},
      {title: '区', dataIndex: 'region'},
      {title: '街道', dataIndex: 'street'},
      {title: '详细地址', dataIndex: 'detailedAddress'},
      {title: '邮编', dataIndex: 'zipCode'},
    ]

    const columns2 = [
      {title: '地址名称', dataIndex: 'addressName'},
      {title: '联系人姓名', dataIndex: 'contacts'},
      {title: '手机号码', dataIndex: 'mobilePhone'},
      {title: '省', dataIndex: 'province'},
      {title: '市', dataIndex: 'city'},
      {title: '区', dataIndex: 'region'},
      {title: '街道', dataIndex: 'street'},
      {title: '详细地址', dataIndex: 'detailedAddress'},
      {title: '邮编', dataIndex: 'zipCode'},
      {title: '揽收方式', dataIndex: 'deliveryType'},
      {title: '揽收周期', dataIndex: 'pickupCycle'},
      {title: '审核状态', dataIndex: 'auditStatus'},
    ]

    const modelRef = reactive<SkuFormDataType>({
      destination: '', //目的国
      productType: 1, //产品类别
      hasBattery: 0, //商品属性
      tradeWay: 'DDP', //贸易方式
      vatIoss: localStorage.getItem('ioss') || '', //VAT/IOSS
      transactionNo: '', //交易单号
      orderWeight: null, //包裹总重量
      amount: null, //包裹总申报价值
      length: null, //长度
      width: null, //宽度
      height: null, //高度
      userName: '', //姓名
      mobilePhone: '', //电话
      countryEn: '', //国家英文名
      province: '', //省/州
      city: '', //城市
      zipCode: '', //邮编
      detailedAddress1: '', //地址1
      detailedAddress2: '', //地址2
      sendName: {},
      getName: {},
      amountCurrency: 'USD',
      email: '',
    })

    const rulesRef = reactive({
      destination: [
        {
          required: true,
          message: '请选择目的国',
        },
      ],
      productType: [
        {
          required: true,
          message: '请选择产品类别',
        },
      ],
      transactionNo: [
        {
          required: false,
          message: '请输入交易单号',
        },
      ],
      vatIoss: [
        {
          required: true,
          validator: (rule: any, value: string, callback: any) => {
            if (value === '' || value == undefined) {
              return Promise.reject('请输入IOSS')
            } else {
              if (isIoss(value)) {
                return Promise.resolve()
              } else {
                return Promise.reject('请输入IM1234567890这样的格式')
              }
            }
          },
        },
      ],
      tradeWay: [
        {
          required: true,
          message: '请选择贸易方式',
        },
      ],
      hasBattery: [
        {
          required: true,
          message: '请选择商品属性',
        },
      ],
      orderWeight: [
        {
          required: true,
          validator: (rule: any, value: string, callback: any) => {
            if (value === '' || value == undefined) {
              return Promise.reject('请输入包裹总重量')
            } else {
              if (Number(value) > 0 && Number(value) <= 15000) {
                return Promise.resolve()
              } else if (parseInt(value) <= 0) {
                return Promise.reject('只能输入大于0的整数')
              } else {
                return Promise.reject('包裹总重量不能大于15kg')
              }
            }
          },
        },
      ],
      amount: [
        {
          required: true,
          validator: (rule: any, value: string, callback: any) => {
            const usdToE = localStorage.getItem('usdtoeur') && Number(localStorage.getItem('usdtoeur'))
            const cnyToE = localStorage.getItem('cnytoeur') && Number(localStorage.getItem('cnytoeur'))
            let exRate: any = modelRef.amountCurrency == 'USD' ? usdToE : modelRef.amountCurrency == 'CNY' ? cnyToE : 1
            console.log('exRate', exRate)
            if (value === '' || value == undefined) {
              return Promise.reject('请输入包裹总价值')
            } else {
              if (Number(value) > 0 && Number(value) * (exRate as number) <= 150) {
                return Promise.resolve()
              } else {
                return Promise.reject('包裹总价值在0.01~150欧元之间')
              }
            }
          },
        },
      ],
      length: [
        {
          required: true,
          validator: (rule: any, value: string, callback: any) => {
            if (value === '' || value == undefined) {
              return Promise.reject('请输入包裹长度')
            } else {
              if (Number(value) > 0 && Number(value) <= 150) {
                return Promise.resolve()
              } else if (parseInt(value) <= 0) {
                return Promise.reject('只能输入大于0的整数')
              } else {
                return Promise.reject('包裹长度不能大于15cm')
              }
            }
          },
        },
      ],
      width: [
        {
          required: true,
          validator: (rule: any, value: string, callback: any) => {
            if (value === '' || value == undefined) {
              return Promise.reject('请输入包裹宽度')
            } else {
              if (Number(value) > 0 && Number(value) <= 150) {
                return Promise.resolve()
              } else if (parseInt(value) <= 0) {
                return Promise.reject('只能输入大于0的整数')
              } else {
                return Promise.reject('包裹宽度不能大于150cm')
              }
            }
          },
        },
      ],
      height: [
        {
          required: true,
          validator: (rule: any, value: string, callback: any) => {
            if (value === '' || value == undefined) {
              return Promise.reject('请输入包裹高度')
            } else {
              if (Number(value) > 0 && Number(value) <= 150) {
                return Promise.resolve()
              } else if (parseInt(value) <= 0) {
                return Promise.reject('只能输入大于0的整数')
              } else {
                return Promise.reject('包裹高度不能大于150cm')
              }
            }
          },
        },
      ],
      userName: [
        {
          required: true,
          message: '请输入收件人姓名',
        },
      ],
      mobilePhone: [
        {
          required: true,
          message: '请输入收件人手机号',
        },
      ],
      countryEn: [
        {
          required: true,
          message: '请选择国家',
        },
      ],
      province: [
        {
          required: true,
          message: '请输入省',
        },
      ],
      city: [
        {
          required: true,
          message: '请输入市',
        },
      ],
      zipCode: [
        {
          required: true,
          validator: (rule: any, value: string, callback: any) => {
            if (value === '' || value == undefined) {
              return Promise.reject('请输入邮编号')
            } else {
              if (isPostal(value)) {
                return Promise.resolve()
              } else {
                return Promise.reject('请输入1~8位的邮编(不含中文及特殊字符)')
              }
            }
          },
        },
      ],
      detailedAddress1: [
        {
          required: true,
          message: '请输入地址1',
        },
      ],
      detailedAddress2: [],
      sendName: [
        {
          required: true,
          message: '请发件人地址名称',
        },
      ],
      getName: [
        {
          required: true,
          message: '请揽收地址名称',
        },
      ],
      amountCurrency: [],
      email: [],
    })

    const {validate, validateInfos} = useForm(modelRef, rulesRef)
    const validateInfosNew = useI18nAntdFormVaildateInfos(validateInfos)

    // 提交
    const postFromData = async (e: MouseEvent) => {
      try {
        const fieldsValue = await validate<SkuFormDataType>()
        console.log('fieldsValue', fieldsValue)
        const productTypeCn = fieldsValue.productType == 1 ? "STD" : "STD"
        const pCode = countrylist.value.filter(
          (item: any) => item.code == fieldsValue.countryEn && item.productCode.indexOf('4PL')  >= 0 && item.productCode.indexOf(productTypeCn)  >= 0
        )
        let productCode = ''
        if (pCode.length > 0) {
          productCode = pCode[0].productCode
        }
        const params = {
          destination: countrylist.value.filter((item: any) => item.name == fieldsValue.destination)[0].code, //目的国
          productType: fieldsValue.productType, //服务产品
          productCode: productCode, //产品编码
          hasBattery: fieldsValue.hasBattery, //商品属性
          tradeWay: fieldsValue.tradeWay, //贸易方式
          vatIoss: fieldsValue.vatIoss, //VAT/IOSS
          transactionNo: fieldsValue.transactionNo, //交易单号
          orderSkuList: skuList.value, //sku信息
          orderWeight: fieldsValue.orderWeight, //包裹总重量
          amount: fieldsValue.amount, //包裹总申报价值
          length: fieldsValue.length, //长度
          width: fieldsValue.width, //宽度
          height: fieldsValue.height, //高度
          addresseeAddess: {
            //收件人信息
            userName: fieldsValue.userName, //姓名
            mobilePhone: fieldsValue.mobilePhone, //电话
            countryEn: countrylist.value.filter((item: any) => item.code == fieldsValue.countryEn)[0].nameEn, //国家英文名
            countryCode2: fieldsValue.countryEn,
            province: fieldsValue.province, //省/州
            city: fieldsValue.city, //城市
            zipCode: fieldsValue.zipCode, //邮编
            detailedAddress1: fieldsValue.detailedAddress1, //地址1
            detailedAddress2: fieldsValue.detailedAddress2, //地址2
            email: fieldsValue.email,
          },
          senderAddess: {...list.value[0], countryCn: '中国', countryEn: 'China', countryCode2: 'CN'}, //发件人信息
          addressCode:  listl.value[0]&&listl.value[0]?.addressCode || '', //揽收人地址信息
          pickupCity:  listl.value[0]&&listl.value[0]?.city || '',  //新增pickupCity
          orderSource: 2, //订单来源
          userCode: userMsg.userCode, //用户编号
          amountCurrency: fieldsValue.amountCurrency, //币种
          pickupType: listl.value[0]?.deliveryType == 1 ? listl.value[0].deliveryType : 2,
        }
        let lwhSub = Number(params.length) + (Number(params.width) + Number(params.height)) * 2 <= 300
        if (params.orderSkuList.length == 0 || params.senderAddess == '' || params.addressCode == '') {
          if (params.orderSkuList.length == 0) {
            message.warning('sku信息表不能为空')
          }
          if (params.senderAddess == '') {
            message.warning('发件人信息表不能为空')
          }
          if (params.addressCode == '') {
            message.warning('揽收地址信息表不能为空')
          }
        } else if (params.addresseeAddess.detailedAddress1 === params.addresseeAddess.detailedAddress2) {
          message.warning('地址1与地址2不能相同')
        } else if (
          params.addresseeAddess.detailedAddress1.length + params.addresseeAddess.detailedAddress2.length >
          96
        ) {
          message.warning('地址1、地址2总长度限制为3 ~ 96 个字符')
        } else if (!lwhSub) {
          message.warning('包裹尺寸范围限制:长+(宽+高)x2≤300cm')
        } else if (Number(params.orderWeight) < Number(wetSub)) {
          message.warning('修改的重量不能小于sku计算的总重量')
        } else if (Number(params.amount) < Number(amSub)) {
          message.warning('修改的申报总价值不能小于sku计算的结果')
        } else if (Number(params.length) < Number(lh)) {
          message.warning('修改后数值不能小于带出长度的数值')
        } else if (Number(params.width) < Number(wh)) {
          message.warning('修改后数值不能小于带出宽度的数值')
        } else if (Number(params.height) < Number(ht)) {
          message.warning('修改后数值不能小于带出高度的数值')
        } else {
          isSubmit.value = true
          const res: boolean = await store.dispatch('addlogistics/submitDataFn', params)
          localStorage.setItem('ioss', modelRef.vatIoss)
          if (res === true) {
            message.success('添加成功')
            isSubmit.value = false
            router.replace({
              path: '/logistics/query',
            })
          }else{
            isSubmit.value = false
          }
        }
      } catch (error) {
        isSubmit.value = false
        console.log('error:', error)
      }
    }

    //获取子组件表单数据
    const getLogistData = async (value: any) => {
      console.log('saveInfo',value)
      saveinfo(value.data, value.type)
    }

    //新增地址
    const saveinfo = async (params: any, type?: string) => {
      loading.value = true
      try {
        const res: boolean = await store.dispatch('setaddress/saveFn', params)
        if (res) {
          visible.value = false
          message.success('添加成功')
          if (type == 'add') {
            getAddressList({userCode: userMsg?.userCode, addressType: 2})
          } else {
            getAddressListL({userCode: userMsg?.userCode, addressType: 1})
          }
        }
      } catch (error) {
        message.warning('error=>' + error)
      }
      loading.value = false
    }

    //弹框标题
    const title = computed<string>(() => {
      const tobj = {
        add: '选择发件人信息',
        Sender: '新增揽收地址信息',
        addSku: '为您的包裹添加sku信息',
        addNewlyAddedSku: '新增SKU',
        default: '添加地址',
      }
      return tobj[typeStr.value] || tobj['default']
    })

    //显示弹框
    const handleModal = (type: string, record?: any) => {
      if (type == 'delete') {
        //删除
        let keys = (localStorage.getItem('keys') && JSON.parse(localStorage.getItem('keys') as string)) || []
        keys.map((item: any, index: number) => {
          if (item == record.id) {
            return keys.splice(index, 1)
          }
        })

        skuList.value = skuList.value.filter((num, index) => {
          return num.id !== record.id
        })
        localStorage.setItem('record', JSON.stringify(skuList.value))
        localStorage.setItem('keys', JSON.stringify(keys))

        if (skuList.value.length == 1) {
          modelRef.length = Number(skuList.value&&skuList.value[0].realLength) != 0 ? skuList.value[0].realLength : skuList.value[0].length
          modelRef.width = Number(skuList.value&&skuList.value[0].realWidth) != 0 ? skuList.value[0].realWidth :skuList.value[0].width
          modelRef.height = Number(skuList.value&&skuList.value[0].realHeight) != 0 ? skuList.value[0].realHeight :skuList.value[0].height
          lh = Number(skuList.value&&skuList.value[0].realLength) != 0 ? skuList.value[0].realLength : skuList.value[0].length
          wh = Number(skuList.value&&skuList.value[0].realWidth) != 0 ? skuList.value[0].realWidth :skuList.value[0].width
          ht = Number(skuList.value&&skuList.value[0].realHeight) != 0 ? skuList.value[0].realHeight :skuList.value[0].height
        } else {
          modelRef.length = null
          modelRef.width = null
          modelRef.height = null
          ;(lh = 0), (wh = 0), (ht = 0)
        }
        changeSub()
      } else {
        typeStr.value = type
        visible.value = true
      }
    }

    //获取发件人信息列表
    // const list = computed<any>(() => store.state.addlogistics.getAddList.addResslist)
    const listSelect = computed<any>(() => store.state.addlogistics.getAddListSelect.addResslist)
    console.log('listSelect',listSelect);
    const getAddressList = async (params: TableListQueryParams) => {
      loading.value = true
      try {
        const res: boolean = await store.dispatch('addlogistics/getPageListFn', params)
        if (res === true) {
          list.value = store.state.addlogistics.getAddList.addResslist
          modelRef.sendName = list.value[0]&&list.value[0]?.addressCode || null
          getAddressListL({userCode: userMsg?.userCode, addressType: 1})
        }
      } catch (error) {
        console.log('error',error);
        message.warning('error=>' + error)
      }
      loading.value = false
    }

    //获取揽收地址信息列表
    // const listl = computed<any>(() => store.state.addlogistics.getAddListl.addsendlist)
    const listlSelect = computed<any>(() => store.state.addlogistics.getAddListlSelect.addsendlist)
    const getAddressListL = async (params: TableListQueryParams) => {
      loadingl.value = true
      try {
        const res: boolean = await store.dispatch('addlogistics/getPageListSendFn', params)
        if (res === true) {
          listl.value = store.state.addlogistics.getAddListl.addsendlist
          modelRef.getName = list.value[0]&&listl.value[0]?.addressCode || null
        }
      } catch (error) {
        console.log('error',error);
        message.warning('error=>' + error)
      }
      loadingl.value = false
    }

    // 新增sku
    const getaddskuData = async (value: any) => {
      value.fieldsValue.userCode = userMsg.userCode
      savesku(value.fieldsValue)
    }
    //保存sku
    const savesku = async (params: SkulistResTableType) => {
      loading.value = true
      try {
        const res: boolean = await store.dispatch('addlogistics/saveSkuFn', params)
        if (res === true) {
          handleModal('addSku')
          message.success('添加成功')
        }
      } catch (error) {
        message.warning('error=>' + error)
      }
      loading.value = false
    }

    // 查询日期有效的币种兑换汇率详情
    const exchangeRate = computed<any>(() => store.state.addlogistics.validInfoData)
    console.log('exchangeRate', exchangeRate)
    const getValidInfoInit = async (params: validInfoType, type: string = '') => {
      try {
        const res: boolean = await store.dispatch('addlogistics/getValidInfoFn', params)
        if (res === true) {
          if (type == 'selectcurrey') {
            modelRef.amount = keepTwoNum((modelRef.amount as number) * (exchangeRate.value as number))
          }
        }
      } catch (error) {
        message.warning('error=>' + error)
      }
    }

    //获取币种选项
    const currtypelist = computed<any[]>(() => store.state.currency.currtypelist.currlist)
    const getcurrenytype = async () => {
      try {
        await store.dispatch('currency/getCurrencyTypeFn')
      } catch (error) {
        console.log('error', error)
        message.warning('error=>' + error)
      }
    }

    const countryName = async () => {
      try {
        const params = {}
        const res: boolean = await store.dispatch('destination/getDestinationFn', params)
        if (res === true) {
          countrylist.value = store.state.destination.destinationList
          const res = new Map()
          countrylistSet.value = countrylist.value.filter((arr: any) => !res.has(arr.name) && res.set(arr.name, 1))
        }
      } catch (error) {
        message.warning('获取国家失败!')
      }
    }

    //获取国家-国籍
    const filterOption = (input: string, option: any) => {
      return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }

    const getIsAddSkuBtn = (value: boolean) => {
      handleModal('addNewlyAddedSku')
    }

    // 添加sku
    const skuEmitData = (e: any) => {
      skuList.value = e
      console.log('object', skuList.value);
      if (skuList.value.length == 1 && skuList.value[0].declareNumber == 1) {
        modelRef.length = Number(skuList.value&&skuList.value[0].realLength) != 0 ? skuList.value[0].realLength : skuList.value[0].length
        modelRef.width = Number(skuList.value&&skuList.value[0].realWidth) != 0 ? skuList.value[0].realWidth :skuList.value[0].width
        modelRef.height = Number(skuList.value&&skuList.value[0].realHeight) != 0 ? skuList.value[0].realHeight :skuList.value[0].height
        lh = Number(skuList.value&&skuList.value[0].realLength) != 0 ? skuList.value[0].realLength : skuList.value[0].length
        wh = Number(skuList.value&&skuList.value[0].realWidth) != 0 ? skuList.value[0].realWidth :skuList.value[0].width
        ht = Number(skuList.value&&skuList.value[0].realHeight) != 0 ? skuList.value[0].realHeight :skuList.value[0].height
      } else {
        modelRef.length = null
        modelRef.width = null
        modelRef.height = null
        ;(lh = 0), (wh = 0), (ht = 0)
      }
      changeSub()
      modelRef.orderSkuList = skuList.value
      visible.value = false
    }

    //选择目的国
    const handleDestination = (e: MouseEvent) => {
      // modelRef.productType = ''
      // const destBody = store.state.destination.destinationBody
      // serveDataList.value = []
      // destBody.filter((item:any)=>{
      //     if(item.destination == modelRef.destination){
      //         serveDataList.value.push({
      //             code:item.productType,
      //             name:item.productNameCn
      //         })
      //     }
      // })
    }

    //模糊查询获取userCode,userName
    const handleSearch = debounce(value => {
      const fetchId = lastFetchId
      const data = {userCode: userMsg?.userCode, addressName: value, auditStatus: 2}
      state.data = []
      fetch(`${process.env.VUE_APP_APIHOST}/seller/v1/userAddress/getUserAddressList`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => response.json())
        .then(res => {
          if (fetchId !== lastFetchId) {
            return
          }
          const {body} = res
          const data = body.map((item: any) => ({
            label: item.addressName,
            value: item.addressCode,
          }))
          state.data = data
        })
    }, 300)
    watch(state.data, () => {
      state.data = []
    })

    //发件人信息
    const handleSelect1 = (value: any) => {
      handleSearch(value)
    }

    //揽收地址信息
    const handleSelect2 = (value: any) => {
      handleSearch(value)
    }

    //发件人信息查询
    const handleChangeSelect = (value: any) => {
      console.log('value', value)
      list.value = listSelect.value.filter((item: any) => item.addressCode == value)
    }

    //揽收地址信息
    const handleChangeSelect2 = (value: any) => {
      // const params = {userCode:userMsg?.userCode,addressName: value.label, addressType:1}
      // getAddressListL(params)
      console.log('valuevaluevaluevalue', value,listlSelect.value)
      listl.value = listlSelect.value.filter((item: any) => item.addressCode == value)
    }

    const handleBack = (type: string) => {
      router.replace({
        path: '/logistics/query',
      })
    }

    //选择目的国后国家是英文
    const handleSelectDes = (e: MouseEvent) => {
      modelRef.countryEn = countrylist.value.filter((item: any) => item.name == modelRef.destination)[0].code
    }

    //改变数量
    const handleChangeNumber = (e: MouseEvent) => {
      changeSub()
      localStorage.setItem('record', JSON.stringify(skuList.value))
    }

    //根据列表数据计算重量及汇率
    const changeSub = () => {
      let accoutNum = 0 //汇率
      let rsub = 0 //实际重量
      let dsub = 0 //申报重量
      skuList.value.map((item: any) => {
        if (item.realWeight > 0) {
          rsub += item.declareNumber * Number(item.realWeight)
        } else {
          dsub += item.declareNumber * Number(item.declareWeight)
        }
        accoutNum += item.declareNumber * Number(item.declareValue)
      })
      let is150 = accoutNum * exchangeRate.value > 150 ? false : true
      if (is150) {
        modelRef.amount = keepTwoNum(accoutNum)
        amSub = keepTwoNum(accoutNum)
      } else {
        message.warning('包裹总价值在0.01~150欧元之间')
      }
      modelRef.orderWeight = Number(rsub + dsub)
      wetSub = Number(rsub + dsub)
    }

    //清除本地缓存
    const loaclStorageremove = () => {
      localStorage.removeItem('keys')
      localStorage.removeItem('record')
      getAddressList({userCode: userMsg?.userCode, addressType: 2})
    }

    //监听币种
    watch(
      () => modelRef.amountCurrency,
      (newValue, oldValue) => {
        const params = {
          exchangeCode: newValue || '',
          formerCode: oldValue || '',
          id: 0,
        }
        getValidInfoInit(params, 'selectcurrey')
      }
    )

    //相应提示
    const handleCheckMsg = (type: string) => {
      switch (type) {
        case 'orderWeight':
          if (Number(modelRef.orderWeight) < Number(wetSub)) {
            message.warning('修改的重量不能小于sku计算的总重量')
          }
          break
        case 'amount':
          if (Number(modelRef.amount) < Number(amSub)) {
            message.warning('修改的申报总价值不能小于sku计算的结果')
          }
          break
        case 'length':
          if (Number(modelRef.length) < Number(lh)) {
            message.warning('修改后数值不能小于带出长度的数值')
          }
          break
        case 'width':
          if (Number(modelRef.width) < Number(wh)) {
            message.warning('修改后数值不能小于带出宽度的数值')
          }
          break
        case 'height':
          if (Number(modelRef.height) < Number(ht)) {
            message.warning('修改后数值不能小于带出高度的数值')
          }
          break
      }
    }

    //检查用户状态
    const getuserstatus = async (params: UserInfoParams) => {
      try {
        const res: boolean = await store.dispatch('userstatus/checkUserStatusFn', params)
        if (res === true) {
          const info: any = store.state.userstatus.info
          console.log('info', info)
          isBoolean.value = info.body
          isNum.value = info.msg
        }
      } catch (error) {
        console.log(error)
      }
    }
    //跳转至验证页面
    const handleGotoCheck = (type: string) => {
      visible.value = false
      if (type == 'check') {
        router.replace('/personal/account')
      } else {
        router.replace('/account/recharge')
      }
    }

    //揽收地址信息枚举转换/显示
    const changeTxt = (t: string, type: string) => {
      const deObj = {
        1: '上门揽收',
        2: '卖家自送',
        3: '卖家邮寄',
      }
      const hObj = {
        0: '普货',
        1: '带电',
      }
      const clObj = {
        1: '周一',
        2: '周二',
        3: '周三',
        4: '周四',
        5: '周五',
        6: '周六',
        7: '周日',
      }
      const audObj = {
        0: '未审核',
        1: '审核中',
        2: '审核通过',
        3: '审核不通过',
      }
      const def = {def: t}
      switch (type) {
        case 'detype':
          return deObj[t] || def['def']
        case 'cycle':
          let txt: string = ''
          t.length > 0 &&
            t.split(',').forEach((i: any) => {
              txt += `${clObj[i]},`
            })
          txt = txt.substring(0, txt.length - 1)
          return txt || def['def']
        case 'hasBattery':
          return hObj[t] || def['def']
        case 'auditStatus':
          return audObj[t] || def['def']
        default:
          return def['def']
      }
    }

    //进来调用相应汇率
    const initGetExRate = async (params: validInfoType, type: string) => {
      try {
        const res: boolean = await store.dispatch('addlogistics/getValidInfoFn', params)
        if (res === true) {
          if (type === 'usdtoeur') {
            localStorage.setItem('usdtoeur', JSON.stringify(store.state.addlogistics.validInfoData))
          }
          if (type === 'cnytoeur') {
            localStorage.setItem('cnytoeur', JSON.stringify(store.state.addlogistics.validInfoData))
          }
        }
      } catch (error) {
        message.warning('error=>' + error)
      }
    }

    //初始化
    const init = () => {
      console.log('@@@', localStorage.getItem('ioss'))
      countryName()
      getuserstatus({userCode: userMsg?.userCode})
      const params = {exchangeCode: 'EUR', formerCode: 'USD', id: 0}
      const params1 = {exchangeCode: 'EUR', formerCode: 'CNY', id: 0}
      initGetExRate(params, 'usdtoeur')
      initGetExRate(params1, 'cnytoeur')
      getcurrenytype()
      loaclStorageremove()
    }

    onMounted(() => {
      init()
    })

    onUnmounted(() => {
      localStorage.removeItem('exRate')
      loaclStorageremove()
    })

    return {
      columns,
      columns1,
      columns2,
      visible,
      typeStr,
      loading,
      loadingl,
      title,
      handleModal,
      filterOption,
      countrylist,
      countrylistSet,
      modelRef,
      validateInfos: validateInfosNew,
      getaddskuData,
      getIsAddSkuBtn,
      list,
      listl,
      listSelect,
      listlSelect,
      skuEmitData,
      skuList,
      postFromData,
      handleDestination,
      serveDataList,
      currtypelist,
      ...toRefs(state),
      isNum,
      isBoolean,
      handleSearch,
      handleSelect1,
      handleSelect2,
      handleChangeSelect,
      handleChangeSelect2,
      getLogistData,
      handleBack,
      handleSelectDes,
      handleChangeNumber,
      handleGotoCheck,
      changeTxt,
      handleCheckMsg,
      isSubmit
    }
  },
})
